import { ITableState } from "./types";
export const initialState: ITableState = {};
